import { render, staticRenderFns } from "./SPUcar.vue?vue&type=template&id=aa81f3b4&scoped=true"
import script from "./SPUcar.vue?vue&type=script&lang=ts"
export * from "./SPUcar.vue?vue&type=script&lang=ts"
import style0 from "./SPUcar.vue?vue&type=style&index=0&id=aa81f3b4&prod&scoped=true&lang=scss"
import style1 from "./SPUcar.vue?vue&type=style&index=1&id=aa81f3b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa81f3b4",
  null
  
)

export default component.exports